<template>
    <v-container grid-list-md text-xs-center>
        <v-layout row wrap>
            <v-flex xs12>
                <v-img src="static/resourceBg.jpg" max-height="380px"></v-img>
            </v-flex>
            <v-flex xs12 md8>
                <v-card>
                    <v-card-title>
                        <h2>Personal Tax Refund Status Check</h2>
                    </v-card-title>
                    <v-card-text class="px-0 text-xs-left">
                        <ul v-for="(tax, i) in taxStatus" :key="i">
                            <li><a style="text-decoration: none" v-bind:href="tax.link"> {{ tax.name }}</a></li>
                        </ul>
                    </v-card-text>
                    <v-divider dark></v-divider>
                </v-card>
                <v-card>
                    <v-card-title>
                        <h2>Useful Tax Forms</h2>
                    </v-card-title>
                    <v-card-text class="px-0 text-xs-left">
                        <ul v-for="(form, i) in forms" :key="i">
                            <li><a style="text-decoration: none" v-bind:href="form.link"> {{ form.name }}</a></li>
                        </ul>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 md4>
                <CompanyContact/>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import CompanyContact from '@/components/common/CompanyContact'
    export default {
        name: "ResourceHome",
        components: {
            CompanyContact
        },
        data: () => ({
            taxStatus: [
                {name: 'IRS/Federal', link: 'https://sa.www4.irs.gov/irfof/lang/en/irfofgetstatus.jsp'},
                {name: 'New York', link: 'https://www8.tax.ny.gov/PRIS/prisStart'},
                {name: 'New Jersey', link: 'https://www16.state.nj.us/TYTR_TGI_INQ/jsp/prompt.jsp'},
                {name: 'IRS/Federal', link: 'https://drsindtax.ct.gov/AUT/welcomeindividual.aspx'}
            ],
            forms: [
                {name: 'W-4 Form', link: 'static/public/W-4+Form.pdf'},
                {name: 'W-9 Form', link: 'static/public/fw9.pdf'}
            ]
        })
    }
</script>

<style scoped>
    .v-image_image {
        height: 300px;
        max-height: 300px;
        background-size: 300px;
    }

    hr {
        width: 100%;
        height: 100%;
        border-width: 1px;
        border-style: solid;
        background-color: snow;
    }
</style>


// WEBPACK FOOTER //
// src/components/resource/ResourceHome.vue